// @flow

import { type IncomingPayment } from '@tectonics/prs/incoming-payment';
import { getMerchantConfigValue } from './get-merchant-config-value';

export function merchantHasOneClickConfig(arg: IncomingPayment | $PropertyType<IncomingPayment, 'merchant'>): boolean {
  return Boolean(getMerchantConfigValue('credit_card_one_click', arg));
}
